import React, { useContext } from 'react';

import { PlatformType } from '@invideoio/web-shared/constants/common';

import { RedirectContext, StateContext } from '../../store/store';
import { PageType } from '@invideoio/web-shared/types/Analytics';

const AdHeaderWithLogo = (props: {
  isAi?: boolean;
  platform?: PlatformType;
  logoURL?: string;
  logoRedirectURL?: string;
  logoClassName?: string;
  isCTAIntersected?: boolean;
  pageType?: PageType;
}) => {
  const globalState = useContext(StateContext);
  const { platform, os, config } = globalState;

  const assetUrl = process.env.NEXT_PUBLIC_SHARED_CDN_URL;
  const aiLogo = `${assetUrl}/logos/invideo_v4_logo_dark.svg`;
  const studioLogo = `${assetUrl}/logos/invideo_v4_logo_dark.svg`;

  const brandLogoURL = props.isAi ? aiLogo : studioLogo;

  return (
    <div className="iv-h-[56px]">
      <div className="iv-fixed iv-w-full iv-z-20 iv-backdrop-blur-[30px] iv-bg-white-75">
        <div className="xl:iv-container xl:iv-mx-auto">
          <header className="iv-sticky sm:iv-relative iv-top-0 iv-z-40 iv-bg-white-75 dark:iv-bg-black-75 iv-px-20">
            <div className="iv-container iv-mx-auto">
              <div className="iv-grid sm:iv-grid-cols-4 md:iv-grid-cols-8 lg:iv-grid-cols-12 xl:iv-grid-cols-12 sm:iv-gap-20 md:iv-gap-25 lg:iv-gap-40 xl:iv-gap-40">
                <div className="iv-flex sm:iv-col-span-4 md:iv-col-span-8 lg:iv-col-start-2 lg:iv-col-span-10 xl:iv-col-start-2 xl:iv-col-span-10 iv-justify-between iv-items-center iv-h-[56px] sm:iv-px-5 md:iv-px-5 lg:iv-px-15">
                  <a
                    target="_self"
                    className="iv-text-body-3xl iv-m-body-3xl iv-font-bold"
                  >
                    {/* helps in centering logo alignment in xl */}
                    <div className="xl:iv-container md:iv-pt-15 xl:iv-mx-auto xl:iv-px-20">
                      <picture>
                        <source
                          height="36"
                          width="116"
                          srcSet={brandLogoURL}
                          media="(min-width: 1480px)"
                        />
                        <source
                          height="40"
                          srcSet={brandLogoURL}
                          media="(min-width: 768px) and (max-width: 1024px)"
                        />
                        <img
                          height="32"
                          width="103.11"
                          alt="invideo logo"
                          src={brandLogoURL}
                        />
                      </picture>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </header>
        </div>
      </div>
    </div>
  );
};

export default AdHeaderWithLogo;
